import { render, staticRenderFns } from "./TemplateFormInfoAssembly.vue?vue&type=template&id=acf8cd08&scoped=true"
import script from "./TemplateFormInfoAssembly.vue?vue&type=script&lang=js"
export * from "./TemplateFormInfoAssembly.vue?vue&type=script&lang=js"
import style0 from "./TemplateFormInfoAssembly.vue?vue&type=style&index=0&id=acf8cd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf8cd08",
  null
  
)

export default component.exports